var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8333 1.66675L16.3821 4.11792C14.5548 2.28648 11.8889 1.29478 9.01069 1.79696C5.65236 2.38362 2.93556 5.0623 2.31473 8.4148C1.33389 13.7031 5.38662 18.3334 10.4999 18.3334C14.7783 18.3334 18.3154 15.091 18.7812 10.9343C18.837 10.4377 18.4479 10.0001 17.9479 10.0001C17.5312 10.0001 17.1726 10.3069 17.1276 10.7211C16.7667 14.0586 13.9324 16.6667 10.4999 16.6667C6.38245 16.6667 3.12508 12.9158 3.96675 8.6508C4.47341 6.08413 6.52794 4.00907 9.09044 3.4799C11.4756 2.9876 13.6933 3.7876 15.2021 5.29793L12.9999 7.50008H18.8333V1.66675Z",
    fill: "#1F4C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.ac6ad96e33eaed06bbfba91c4f0fd11d.svg";
export { ForwardRef as ReactComponent };